import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { useIsOrgOwner } from "@/hooks/organizations";
import { useState } from "react";
import CreateInviteForm from "../../components/CreateInviteForm";

const InviteMember = () => {
  const [open, setOpen] = useState(false);
  const isOrgOwner = useIsOrgOwner();

  if (!isOrgOwner)
    return (
      <span className="ml-4 text-sm text-gray-500">
        Contact the admin to invite members
      </span>
    );

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button size="sm" onClick={() => setOpen(true)}>
          Invite
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Invite to Workspace</DialogTitle>
        </DialogHeader>
        <CreateInviteForm onSuccess={() => setOpen(false)} />
      </DialogContent>
    </Dialog>
  );
};

export default InviteMember;
